module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av488-3fc91323afce460a4aa06cf04994d33e.jpg";